import { cn } from '@elara/client-core/lib/utils';

/** A label + full-width rule used as a subtle section header within cards and dialogs. */
export function SectionDivider({ label, className }: { label: string; className?: string }) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="font-medium text-xs text-muted-foreground">{label}</div>
      <div className="h-px bg-border flex-1" />
    </div>
  );
}
